import React from "react";
import { createPortal } from "react-dom";

export const DeleteConfirmDialog = ({ busy, onCancel, onConfirm, open }) => {
  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[110] bg-[#1E2A24]/65"
      role="dialog"
      aria-modal="true"
      aria-labelledby="admin-delete-confirm-title"
      data-testid="admin-delete-confirm-modal"
    >
      <div
        className="fixed left-1/2 top-1/2 z-[111] w-[calc(100vw-2rem)] max-w-[360px] border border-[#E2DCD2] bg-white p-6 shadow-2xl"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <h2
          id="admin-delete-confirm-title"
          className="font-serif text-xl font-semibold text-[#1E2A24]"
        >
          Are you sure you want to delete this?
        </h2>
        <p className="mt-2 text-sm leading-6 text-[#64748B]">
          This action cannot be undone.
        </p>
        <div className="mt-6 grid grid-cols-2 gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="border border-[#E2DCD2] px-3 py-2.5 text-sm font-semibold text-[#64748B] hover:text-[#1E2A24] disabled:opacity-50"
            data-testid="admin-delete-cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className="bg-[#9B2C2C] px-3 py-2.5 text-sm font-semibold text-white hover:bg-[#7F1D1D] disabled:opacity-50"
            data-testid="admin-delete-confirm"
          >
            {busy ? "Deleting…" : "Confirm Delete"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};